import axios from "axios";


const UnauthAxios = axios.create();


export default UnauthAxios;